import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import DocumentsList from './DocumentsList'
import DocumentProfile from './DocumentProfile'

export default function Documents() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/documents" component={DocumentsList} />
				<Route exact path="/documents/:id" component={DocumentProfile} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}